import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'
import {
  tiens, tiens_phieuchi, tiens_phieuthu, tiens_bangkethanhtoan, tiens_baoco, tiens_baono, tiens_rutdutoan_vaotk
  , tiens_cknoibo, tiens_rutdutoan_ck, tonghops_chungtukhac, tiens_nhandutoan, tiens_huydutoan
  , tiens_dcdutoan, tiens_rutdutoan_tiengui, tiens_rutdutoan_nhapquy, Lists_chuong, Lists_loaikhoan, Lists, Lists_nguonkinhphi, Lists_caphat
  , taisan_ban, taisan_danhgia, taisan_ghigiam, taisan_mua, taisan_nhanhienvat
  , taisan_haomon, tiens_camketchi, tiens_dccamketchi, congcus_dieuchuyencongcu, congcus_ghigiam, congcus_ghitang
  , Products_muahang, Products_nhapkho, congcus_phanbo, Products_xuatkho, Products_nhapkhocongcu, tiens_camketchidauky, tiens_rutdutoan_ctuck, tiens_rutdutoan_tienmat, payroll_noptncn, payroll_hachtoanluong, payroll_baohiem, payroll_traluong, tiens_rutdutoan_ck_ts, tiens_giulaidutoan
} from '../../../routes/menu';

const swal = require('sweetalert');
@Component({
    selector: 'app-baocao-luoichitietedit',
    templateUrl: './luoichitietedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
    styleUrls: ['./luoichitietedit.component.scss'],
    providers: [ListService, Repository]
})


export class luoichitieteditComponent implements OnInit {

   
    
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    inputparents: any
    indLoading: boolean = false;    
    hoatdong: string = null;
    dataGridTimKiem: any;
    sobanghi: number;
    dataGrid: any;
    datatieude: any;
    public currentUser;

    @ViewChild('slCapTren',{static:false}) slCapTren: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
    @Output() changeCT: EventEmitter<any> = new EventEmitter();
    //@ViewChild('modalpc', { static: false }) modalpc: ModalComponent;
    //@ViewChild('ctphieuchiedit', { static: false }) phieuchiedit: any;
    //@ViewChild('modalpt', { static: false }) modalpt: ModalComponent;
    //@ViewChild('ctphieuthuedit', { static: false }) phieuthuedit: any;
    //@ViewChild('modalbangkethanhtoan', { static: false }) modalbangkethanhtoan: ModalComponent;
    //@ViewChild('bangkethanhtoanedit', { static: false }) bangkethanhtoanedit: any;
    //@ViewChild('modalbaoco', { static: false }) modalbaoco: ModalComponent;
    //@ViewChild('ctbaocoedit', { static: false }) ctbaocoedit: any;
    //@ViewChild('modalbaono', { static: false }) modalbaono: ModalComponent;
    //@ViewChild('ctbaonoedit', { static: false }) ctbaonoedit: any;
    //@ViewChild('modaltonghop', { static: false }) modaltonghop: ModalComponent;
    //@ViewChild('cttonghopedit', { static: false }) cttonghopedit: any;
    //@ViewChild('modalchuyentiennoibo', { static: false }) modalchuyentiennoibo: ModalComponent;
    //@ViewChild('ctchuyentiennoiboedit', { static: false }) ctchuyentiennoiboedit: any;
    //@ViewChild('modalrutdutoanck', { static: false }) modalrutdutoanck: ModalComponent;
    //@ViewChild('ctrutdutoanckedit', { static: false }) ctrutdutoanckedit: any;

    //@ViewChild('modalnhandutoan', { static: false }) modalnhandutoan: ModalComponent;
    //@ViewChild('ctnhandutoanedit', { static: false }) ctnhandutoanedit: any;
    //@ViewChild('modalhuydutoan', { static: false }) modalhuydutoan: ModalComponent;
    //@ViewChild('cthuydutoanedit', { static: false }) cthuydutoanedit: any;
    //@ViewChild('modaldcdutoan', { static: false }) modaldcdutoan: ModalComponent;
    //@ViewChild('ctdcdutoanedit', { static: false }) ctdcdutoanedit: any;
    //@ViewChild('modalruttg', { static: false }) modalruttg: ModalComponent;
    //@ViewChild('ctrutdutoantgedit', { static: false }) ctrutdutoantgedit: any;
    //@ViewChild('modalcktaisan', { static: false }) modalcktaisan: ModalComponent;
    //@ViewChild('ctcktaisanedit', { static: false }) ctcktaisanedit: any;
    //@ViewChild('modalnhantaisan', { static: false }) modalnhantaisan: ModalComponent;
    //@ViewChild('ctnhantaisanedit', { static: false }) ctnhantaisanedit: any;
    //@ViewChild('modalghigiamtaisan', { static: false }) modalghigiamtaisan: ModalComponent;
    //@ViewChild('ctghigiamtaisanedit', { static: false }) ctghigiamtaisanedit: any;
    //@ViewChild('modalbantaisan', { static: false }) modalbantaisan: ModalComponent;
    //@ViewChild('ctbantaisanedit', { static: false }) ctbantaisanedit: any;
    //@ViewChild('modalmuataisan', { static: false }) modalmuataisan: ModalComponent;
    //@ViewChild('ctmuataisanedit', { static: false }) ctmuataisanedit: any;
    //@ViewChild('modalnhanhienvat', { static: false }) modalnhanhienvat: ModalComponent;
    //@ViewChild('ctnhanhienvatedit', { static: false }) ctnhanhienvatedit: any;
    //@ViewChild('modaltinhhaomontaisan', { static: false }) modaltinhhaomontaisan: ModalComponent;
    //@ViewChild('cttinhhaomontaisanedit', { static: false }) cttinhhaomontaisanedit: any;
    //@ViewChild('modalcamketchi', { static: false }) modalcamketchi: ModalComponent;
    //@ViewChild('ctcamketchiedit', { static: false }) ctcamketchiedit: any;
    //@ViewChild('modaldieuchinhcamketchi', { static: false }) modaldieuchinhcamketchi: ModalComponent;
    //@ViewChild('ctdieuchinhcamketchiedit', { static: false }) ctdieuchinhcamketchiedit: any;
    //@ViewChild('modaldieuchuyencongcu', { static: false }) modaldieuchuyencongcu: ModalComponent;
    //@ViewChild('ctdieuchuyencongcuedit', { static: false }) ctdieuchuyencongcuedit: any;
    //@ViewChild('modalghigiamcongcu', { static: false }) modalghigiamcongcu: ModalComponent;
    //@ViewChild('ctghigiamcongcuedit', { static: false }) ctghigiamcongcuedit: any;
    //@ViewChild('modalghitangcongcu', { static: false }) modalghitangcongcu: ModalComponent;
    //@ViewChild('ctghitangcongcuedit', { static: false }) ctghitangcongcuedit: any;
    //@ViewChild('modalmuacongcu', { static: false }) modalmuacongcu: ModalComponent;
    //@ViewChild('ctmuacongcuedit', { static: false }) ctmuacongcuedit: any;
    //@ViewChild('modalnhapkho', { static: false }) modalnhapkho: ModalComponent;
    //@ViewChild('ctnhapkhoedit', { static: false }) ctnhapkhoedit: any;
    //@ViewChild('modalphanbocongcu', { static: false }) modalphanbocongcu: ModalComponent;
    //@ViewChild('ctphanbocongcuedit', { static: false }) ctphanbocongcuedit: any;
    //@ViewChild('modalxuatkho', { static: false }) modalxuatkho: ModalComponent;
    //@ViewChild('ctxuatkhoedit', { static: false }) ctxuatkhoedit: any;


  

  doubleClick(row) {
    this.datatieude.forEach((item: any) => {
      if (item.ColumnName.toLowerCase() == "idchungtu") {
        // hiển thị lên form chứng từ phiếu chi
        this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: row.IDCHUNGTU })
          .subscribe(response => {
            //console.log("taiu");
            //console.log(response.Phan_He_Id);
            if (response.Phan_He_Id.toLowerCase() == tiens_phieuchi.id.toLowerCase()) {
              window.open('/#/ketoan/phieuchi/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_phieuthu.id.toLowerCase()) {
              window.open('/#/ketoan/phieuthu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_nhapquy.id.toLowerCase()) {
              window.open('/#/ketoan/rutdutoannhapquy/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_ctuck.id.toLowerCase()) {
              window.open('/#/ketoan/chungtudutoanck/' + response.Id);
              return;
            }

            if (response.Phan_He_Id.toLowerCase() == tiens_baoco.id.toLowerCase()
              || response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_vaotk.id.toLowerCase()
            ) {
              window.open('/#/ketoan/baoco/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_baono.id.toLowerCase()) {
              window.open('/#/ketoan/baono/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tonghops_chungtukhac.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == ('046EBE47-3190-4046-9458-AA2AEF01F238').toLowerCase()) {
              //console.log("taotao");
              window.open('/#/ketoan/chungtukhac/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_cknoibo.id.toLowerCase()) {
              window.open('/#/ketoan/chuyentiennoibo/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_tienmat.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_tiengui.id.toLowerCase()
              || response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_ck.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_ck_ts.id.toLowerCase()
            ) {
              window.open('/#/ketoan/rutdutoan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_nhandutoan.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == tiens_dcdutoan.id.toLowerCase()
              || response.Phan_He_Id.toLowerCase() == tiens_huydutoan.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == tiens_giulaidutoan.id.toLowerCase()
            ) {
              window.open('/#/ketoan/nhandutoan/' + response.Id);
              return;
            }

            if (response.Phan_He_Id.toLowerCase() == taisan_ban.id.toLowerCase()) {
              window.open('/#/ketoan/bantaisan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == taisan_danhgia.id.toLowerCase()) {
              window.open('/#/ketoan/danhgiataisan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == taisan_ghigiam.id.toLowerCase()) {
              window.open('/#/ketoan/ghigiamtaisan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == taisan_mua.id.toLowerCase()) {
              window.open('/#/ketoan/muataisan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == taisan_nhanhienvat.id.toLowerCase()) {
              window.open('/#/ketoan/nhanhienvat/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == taisan_haomon.id.toLowerCase()) {
              window.open('/#/ketoan/tinhhaomontaisan/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_camketchi.id.toLowerCase()) {
              window.open('/#/ketoan/camketchi/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_dccamketchi.id.toLowerCase()) {
              window.open('/#/ketoan/dccamketchi/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == tiens_camketchidauky.id.toLowerCase()) {
              window.open('/#/ketoan/camketchi/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == congcus_dieuchuyencongcu.id.toLowerCase()) {
              window.open('/#/ketoan/dieuchuyencongcu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == congcus_ghigiam.id.toLowerCase()) {
              window.open('/#/ketoan/ghigiamcongcu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == congcus_ghitang.id.toLowerCase()) {
              window.open('/#/ketoan/ghitangcongcu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == Products_muahang.id.toLowerCase()) {
              window.open('/#/ketoan/muacongcu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == Products_nhapkho.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == Products_nhapkhocongcu.id.toLowerCase()) {

              window.open('/#/ketoan/nhapkho/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == congcus_phanbo.id.toLowerCase()) {
              window.open('/#/ketoan/phanbocongcu/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == Products_xuatkho.id.toLowerCase()) {
              window.open('/#/ketoan/xuatkho/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == payroll_noptncn.id.toLowerCase()) {
              window.open('/#/ketoan/nopTNCN/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == payroll_hachtoanluong.id.toLowerCase()) {
              window.open('/#/ketoan/hachtoanluong/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == payroll_baohiem.id.toLowerCase()) {
              window.open('/#/ketoan/nopbaohiem/' + response.Id);
              return;
            }
            if (response.Phan_He_Id.toLowerCase() == payroll_traluong.id.toLowerCase()) {
              window.open('/#/ketoan/traluong/' + response.Id);
              return;
            }

            //if (response.Phan_He_Id.toLowerCase() == tiens_phieuchi.id.toLowerCase()) {
            //  this.phieuchiedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modalpc.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_phieuthu.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_nhapquy.id.toLowerCase()) {
            //  this.phieuthuedit.loadDataInit(row.IDCHUNGTU, 0, tiens_phieuthu.id, null);
            //  this.modalpt.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_bangkethanhtoan.id.toLowerCase()) {
            //  this.bangkethanhtoanedit.loadDataInit(row.IDCHUNGTU, 0, tiens_bangkethanhtoan.id, null);
            //  this.modalbangkethanhtoan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_baoco.id.toLowerCase()) {
            //  this.ctbaocoedit.loadDataInit(row.IDCHUNGTU, 0, tiens_baoco.id, null);
            //  this.modalbaoco.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_baono.id.toLowerCase()) {
            //  this.ctbaonoedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modalbaono.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tonghops_chungtukhac.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == ('046EBE47-3190-4046-9458-AA2AEF01F238').toLowerCase()) {
            //  //console.log("taotao");
            //  this.cttonghopedit.loadDataInit(row.IDCHUNGTU, 0, response.Phan_He_Id, null);
            //  this.modaltonghop.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_cknoibo.id.toLowerCase()) {
            //  this.ctchuyentiennoiboedit.loadDataInit(row.IDCHUNGTU, 0, tiens_cknoibo.id, null);
            //  this.modalchuyentiennoibo.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_ck.id.toLowerCase()) {
            //  this.ctrutdutoanckedit.loadDataInit(row.IDCHUNGTU, 0, tiens_rutdutoan_ck.id, null);
            //  this.modalrutdutoanck.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_nhandutoan.id.toLowerCase()) {
            //  this.ctnhandutoanedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modalnhandutoan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_huydutoan.id.toLowerCase()) {
            //  this.cthuydutoanedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modalhuydutoan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_dcdutoan.id.toLowerCase()) {
            //  this.ctdcdutoanedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modaldcdutoan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_rutdutoan_tiengui.id.toLowerCase()) {
            //  this.ctrutdutoantgedit.loadDataInit(row.IDCHUNGTU, 0, tiens_rutdutoan_tiengui.id, null);
            //  this.modalruttg.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_ban.id.toLowerCase()) {
            //  this.ctcktaisanedit.loadDataInit(row.IDCHUNGTU, 0, taisan_ban.id, null);
            //  this.modalcktaisan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_danhgia.id.toLowerCase()) {
            //  this.ctnhantaisanedit.loadDataInit(row.IDCHUNGTU, 0, taisan_danhgia.id, null);
            //  this.modalnhantaisan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_ghigiam.id.toLowerCase()) {
            //  this.ctghigiamtaisanedit.loadDataInit(row.IDCHUNGTU, 0, taisan_ghigiam.id, null);
            //  this.modalghigiamtaisan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_mua.id.toLowerCase()) {
            //  this.ctmuataisanedit.loadDataInit(row.IDCHUNGTU, 0, taisan_mua.id, null);
            //  this.modalmuataisan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_nhanhienvat.id.toLowerCase()) {
            //  this.ctnhanhienvatedit.loadDataInit(row.IDCHUNGTU, 0, taisan_nhanhienvat.id, null);
            //  this.modalnhanhienvat.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == taisan_haomon.id.toLowerCase()) {
            //  this.cttinhhaomontaisanedit.loadDataInit(row.IDCHUNGTU, 0, taisan_haomon.id, null);
            //  this.modaltinhhaomontaisan.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_camketchi.id.toLowerCase()) {
            //  this.ctcamketchiedit.loadDataInit(row.IDCHUNGTU, 0, tiens_camketchi.id);
            //  this.modalcamketchi.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == tiens_dccamketchi.id.toLowerCase()) {
            //  this.ctdieuchinhcamketchiedit.loadDataInit(row.IDCHUNGTU, 0);
            //  this.modaldieuchinhcamketchi.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == congcus_dieuchuyencongcu.id.toLowerCase()) {
            //  this.ctdieuchuyencongcuedit.loadDataInit(row.IDCHUNGTU, 0, congcus_dieuchuyencongcu.id, null);
            //  this.modaldieuchuyencongcu.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == congcus_ghigiam.id.toLowerCase()) {
            //  this.ctghigiamcongcuedit.loadDataInit(row.IDCHUNGTU, 0, congcus_ghigiam.id, null);
            //  this.modalghigiamcongcu.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == congcus_ghitang.id.toLowerCase()) {
            //  this.ctghitangcongcuedit.loadDataInit(row.IDCHUNGTU, 0, congcus_ghitang.id, null);
            //  this.modalghitangcongcu.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == Products_muahang.id.toLowerCase()) {
            //  this.ctmuacongcuedit.loadDataInit(row.IDCHUNGTU, 0, Products_muahang.id, null);
            //  this.modalmuacongcu.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == Products_nhapkho.id.toLowerCase() || response.Phan_He_Id.toLowerCase() == Products_nhapkhocongcu.id.toLowerCase()) {
              
            //  this.ctnhapkhoedit.loadDataInit(row.IDCHUNGTU, 0, response.Phan_He_Id, null);
            //  this.modalnhapkho.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == congcus_phanbo.id.toLowerCase()) {
            //  this.ctphanbocongcuedit.loadDataInit(row.IDCHUNGTU, 0, congcus_phanbo.id, null);
            //  this.modalphanbocongcu.open();
            //  return;
            //}
            //if (response.Phan_He_Id.toLowerCase() == Products_xuatkho.id.toLowerCase()) {
            //  this.ctxuatkhoedit.loadDataInit(row.IDCHUNGTU, 0, Products_xuatkho.id, null);
            //  this.modalxuatkho.open();
            //  return;
            //}

          });
      }



    });
  }
  savept(doituong: any) {
    

    //this.modalpc.dismiss();
    //this.modalpt.dismiss();
    //this.modalbangkethanhtoan.dismiss();
    //this.modalbaoco.dismiss();
    //this.modalbaono.dismiss();
    //this.modaltonghop.dismiss();
    //this.modalchuyentiennoibo.dismiss();
    //this.modalrutdutoanck.dismiss();
    //this.modalnhandutoan.dismiss();
    //this.modalhuydutoan.dismiss();
    //this.modaldcdutoan.dismiss();
    //this.modalruttg.dismiss();
    //this.modalcktaisan.dismiss();
    //this.modalnhantaisan.dismiss();
    //this.modalghigiamtaisan.dismiss();
    //this.modalmuataisan.dismiss();
    //this.modalnhanhienvat.dismiss();
    //this.modaltinhhaomontaisan.dismiss();
    //this.modalcamketchi.dismiss();
    //this.modaldieuchinhcamketchi.dismiss();
    //this.modaldieuchuyencongcu.dismiss();
    //this.modalghigiamcongcu.dismiss();
    //this.modalghitangcongcu.dismiss();
    //this.modalmuacongcu.dismiss();
    //this.modalnhapkho.dismiss();
    //this.modalphanbocongcu.dismiss();
    //this.modalxuatkho.dismiss();
    if (doituong != null) {
      // tải lại lưới khi sửa chứng từ
      this.changeCT.emit(1);
    }
    else {
      // tải lại lưới khi sửa chứng từ
      this.changeCT.emit(null);
    }
    //if (doituong != null) {
    //  this.export('table');
    //  if (doituong.Phan_He_Id.toLowerCase() == tiens_phieuchi.id.toLowerCase()) {
    //    this.modalpc.dismiss();
    //  }
    //  if (doituong.Phan_He_Id.toLowerCase() == tiens_phieuthu.id.toLowerCase()) {
    //    this.modalpt.dismiss();
    //  }
    //}
    //else {
    //  this.modalpc.dismiss();
    //  this.modalpt.dismiss();
    //}

  }
  changesearch(value) {
    let datatam = this.dataGridTimKiem;
    //console.log(datatam);
    this.datatieude.forEach((item: any) => {
      if (item.TimKiem != null && item.TimKiem != "") {
        datatam = datatam.filter((s) => s[item.ColumnName] !== null && s[item.ColumnName].toString().toLowerCase().indexOf(item.TimKiem.toLowerCase()) !== -1);

      }
    });
    this.dataGrid = datatam;

  }

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

   
  loadDataInit(data: any) {

    this.dataGrid = data.dataGrid;
    this.dataGridTimKiem = data.dataGridTimKiem;
    this.datatieude = data.datatieude;
    this.sobanghi=data.sobanghi;
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    

    
   

   


}
